import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../core/redux/store';

// Extend Window interface for Crisp chat globals
declare global {
  interface Window {
    $crisp?: any[];
    CRISP_WEBSITE_ID?: string;
  }
}

interface CrispChatProps {
  enabledAddons?: any;
}

const CrispChat: React.FC<CrispChatProps> = () => {
  const headerData = useSelector((state: RootState) => state.common.header);
  const scriptLoaded = useRef(false);

  useEffect(() => {
    // Check if chat addon is enabled in the enabled_addons data
    const enabledAddons = headerData?.enabled_addons;

    const isChatEnabled = enabledAddons && Array.isArray(enabledAddons) && enabledAddons.find((addon: any) => {
      if (addon.add_on_name === 'Crisp' && addon.data) {
        try {
          let data = JSON.parse(addon.data);
          // Check if data is still a string (double-encoded JSON)
          if (typeof data === 'string') {
            data = JSON.parse(data);
          }
          const hasWebsiteId = !!data.website_id;
          return hasWebsiteId;
        } catch (e) {
          return false;
        }
      }
      return false;
    });
    if (isChatEnabled && !scriptLoaded.current) {
      // Load Crisp.chat script dynamically
      const loadCrispChatScript = () => {
        // Remove any existing Crisp scripts
        document.querySelectorAll('[data-crisp-script]').forEach(script => script.remove());

        // Create and inject Crisp.chat script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('data-crisp-script', 'true');
        script.async = true;
        // Set the Crisp chat initialization code
        window.$crisp = [];
        let parsedData = JSON.parse(isChatEnabled.data);
        // Check if data is still a string (double-encoded JSON)
        if (typeof parsedData === 'string') {
          parsedData = JSON.parse(parsedData);
        }
        window.CRISP_WEBSITE_ID = parsedData.website_id;
        
        // Create the actual Crisp script loader
        const crispScript = document.createElement('script');
        crispScript.src = "https://client.crisp.chat/l.js";
        crispScript.async = true;
        
        document.head.appendChild(crispScript);
        scriptLoaded.current = true;
      };

      loadCrispChatScript();
    } else if (!isChatEnabled && scriptLoaded.current) {
      // Remove Crisp script if chat is disabled
      document.querySelectorAll('[data-crisp-script]').forEach(script => script.remove());
      
      // Also remove any Crisp widgets if they exist
      const crispWidget = document.querySelector('[class*="crisp-"]');
      if (crispWidget) {
        crispWidget.remove();
      }
      
      // Clear Crisp global variables
      if (window.$crisp) {
        window.$crisp = [];
      }
      delete window.CRISP_WEBSITE_ID;
      
      scriptLoaded.current = false;
    }
  }, [headerData?.enabled_addons]);

  return null; // This component doesn't render anything visible
};

export default CrispChat;
